//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import orderCreatable from "~/mixins/orderCreateable.js";

export default {
  mixins: [orderCreatable],

  props: {
    content: {
      required: true,
    },
  },
  data() {
    return {
      showTable: false,
    };
  },
  computed: {
    url() {
      if (this.form)
        return `/orders/create/formation/${this.form}?&entity=LLC&package=`;
      else return `/orders/create/formation?&entity=LLC&package=`;
    },
  },
  methods: {},
};
